import angular from 'angular';

/**
 * @param {string} label
 * @param {string} shortcut
 * @returns {string}
 */
const shortcutFilter = (label, shortcut) => {
	if (!shortcut || !/^[A-Za-z]$/.test(shortcut)) {
		return label;
	}

	const match = label.match(new RegExp(shortcut, 'i'));

	if (!match || match.index === undefined) {
		return label;
	}

	const index = match.index + 1;
	const lowLine = '\u0332';

	return label.slice(0, Math.max(0, index)) + lowLine + label.slice(Math.max(0, index));
};

// eslint-disable-next-line angular/function-type
angular.module('app')
	.filter('shortcut', () => shortcutFilter);
